import React from "react";
import "./404.scss";
import withMotion from "../Utils/withMotion";

const PageNotFound = () => {
  return (
    <div className="page-missing">
      <h1 className="mt-5">Page Not Found</h1>
    </div>
  );
};

export default withMotion(PageNotFound);
